import { devicesQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useDeleteDevice() {
  const toast = useToast();
  const { t } = useI18n();

  return useNosIdMutation({
    mutationFn: async ({ id, sa }: { sa: string; id: string }) => {
      return api.delete('/api/v1/device-management/:accountId/devices/:deviceId', {
        params: { accountId: sa, deviceId: id },
      });
    },
    successLogAction: () => ({ ActionType: ActionType.DeviceManagement }),
    errorLogAction: () => ({ ActionType: ActionType.DeviceManagement }),
    onSuccess: (_payload, { sa, id }, _result, { client }) => {
      client.setQueryData(devicesQueryOptions(sa).queryKey, (old) =>
        old?.filter((device) => device.Id !== id),
      );
      toast.show('success', t('Common.SnackBar.DeviceRemoved'));
    },
  });
}
